import React from 'react';
import { IStore } from "../../../redux/reducers";
import { useSelector } from "react-redux";
import { View } from 'react-native';
import { IOrgJobListItem, JobStatus } from '../../../models';
import { Badge, Menu, Pressable, Box, Text, useColorModeValue } from 'native-base';

import { getDisplayableJobId, getBadgeColor, getStatusMessage, getFormattedDate } from '../../../utils/jobUtils'
import { listStyle } from 'src/styles/listStyle';
import { cardStyle } from 'src/styles/cardStyle';
import TextWithIcon from '../../TextWithIcon';
import MaterialIconByName from '../../MaterialIconByName';

interface OrgJobHistoryListItemProps {
    item: IOrgJobListItem;
    itemCallback: (item: IOrgJobListItem) => void;
    downloadImageCallback: (jobId: string) => void;
    retryJobCallback: (item: IOrgJobListItem) => void;
    localProfileName?: string;
}

export default function OrgJobHistoryListItem(props: OrgJobHistoryListItemProps) {

    const grainTypes = useSelector((store: IStore) => store.user.userProfile.response?.grains);
    const textColor = useColorModeValue('coolGray.800', 'coolGray.100');
    const cardBgColor = useColorModeValue('coolGray.100', 'coolGray.800');
    const borderColor = useColorModeValue('coolGray.300', 'coolGray.600');

    const getGrainWithProfileName = (grainId: string, profileId?: string): string => {
        const grainName = grainTypes?.filter(grain => grain.grainId === grainId)[0]?.name || "";
        
        if (!profileId) {
            return grainName;
        }
        
        // Find the grain that matches the grainId
        const grain = grainTypes?.find(g => g.grainId === grainId);
        
        // Find the profile within that grain's profiles array
        const profile = grain?.profiles?.find(p => p.profileId === profileId);
        const profileName = profile?.profileName || props.localProfileName;
        
        if (profileName) {
            return `${grainName} (${profileName})`;
        }
        
        return grainName;
    }

    return (
        <Pressable
            onPress={() => {
                props.itemCallback(props.item)
            }}
            style={cardStyle.normalCard}
            rounded="8"
            overflow="hidden"
            borderWidth="1"
            borderColor={borderColor}
            shadow="3"
            bg={cardBgColor} p="4">
            <Box>
                <View style={listStyle.cardSection}>
                    <View style={{ width: "45%" }}>
                        <Text color={textColor} style={listStyle.title}>Job ID: {getDisplayableJobId(props.item.jobId)}</Text>
                        <View style={{
                            marginTop: 8,
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            rowGap: 8,
                        }}>
                            <TextWithIcon icon="barley" text={getGrainWithProfileName(props.item.grainId, props.item.profileId)} />
                            <TextWithIcon icon="clock-time-nine" text={getFormattedDate(props.item.createdAt)} />
                            {/* <TextWithIcon icon="account" text={props.item.username} />
                            <TextWithIcon icon="map-marker" text={props.item.centerName} /> */}
                        </View>
                    </View>
                    <View style={{ justifyContent: 'center' }}>
                        <View style={{ flexDirection: "row" }}>
                            <Badge variant='solid' colorScheme={getBadgeColor(props.item.jobStatus)}>{getStatusMessage(props.item.jobStatus)}</Badge>
                            <View style={{ justifyContent: 'center', marginLeft: 8 }}>
                                <Menu trigger={triggerProps => {
                                    return <Pressable accessibilityLabel="More options" {...triggerProps}>
                                        <MaterialIconByName name="dots-vertical" />
                                    </Pressable>;
                                }}>
                                    {
                                        <Menu.Item onPress={() => {
                                            props.retryJobCallback(props.item)
                                        }}>Retry</Menu.Item>
                                    }
                                    <Menu.Item onPress={() => {
                                        props.downloadImageCallback(props.item.jobId)
                                    }}>Download image</Menu.Item>
                                </Menu>
                            </View>
                        </View>
                    </View>

                </View>
            </Box>
        </Pressable>

    );


};
